<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="$router.back();"
        >
          返回
        </el-button>
      </el-col>
    </el-row>

    <el-form
        :model="info"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
    >
      <el-form-item label="标题" prop="title">
        <el-input
            v-model="info.title"
            maxlength="30"
            show-word-limit
            style="width:33%"
        ></el-input>
      </el-form-item>
      <el-form-item label="图片">
        <el-upload
            class="avatar-uploader"
            :action="ossAction"
            :show-file-list="false"
            :http-request="uploadOSSRequest"
            :before-upload="beforeImageUpload"
        >
          <img v-if="info.img_url" :src="info.img_url" class="avatar"/>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb，尺寸750x560 px
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="价格" prop="price">
        <el-input v-model="info.price" style="width:50%"></el-input>
      </el-form-item>

      <el-form-item label="iOS价格" prop="ios_price">
        <el-input v-model="info.ios_price" style="width:50%"></el-input>
      </el-form-item>

      <!--      <el-form-item label="是否优惠">-->
      <!--          <el-radio v-model="info.is_discount" label="0">没有优惠</el-radio>-->
      <!--          <el-radio v-model="info.is_discount" label="1">正常优惠</el-radio>-->
      <!--      </el-form-item>-->
      <el-form-item label="是否优惠">
        <el-radio-group v-model="info.is_discount">
          <el-radio :label="0">没有优惠</el-radio>
          <el-radio :label="1">正常优惠</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="info.is_discount==1" label="优惠价格" prop="discount_price">
        <el-input v-model="info.discount_price" style="width:50%"></el-input>
      </el-form-item>
      <el-form-item v-if="info.is_discount==1" label="iOS优惠价格" prop="ios_discount_price">
        <el-input v-model="info.ios_discount_price" style="width:50%"></el-input>
      </el-form-item>

      <el-form-item label="发布时间">
        <el-date-picker
            v-model="info.released_at"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择发布时间"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="咨询师">
        <el-select
            class="search-el"
            size="mini"
            v-model="info.teacher_id"
            placeholder="请选择"
            clearable
            filterable
        >
          <el-option
              v-for="item in teacherList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="预约须知">
        <tinymce v-model="info.detail" style="width:66%"></tinymce>
      </el-form-item>

      <el-form-item label="客服二维码">
        <el-upload
            class="avatar-uploader"
            :action="ossAction"
            :show-file-list="false"
            :http-request="imageUploadOSSRequest3"
            :before-upload="beforeImageUpload"
            accept="image/*"
        >
          <img v-if="info.wechat_img" :src="info.wechat_img" class="avatar2"/>
          <i v-else class="el-icon-plus avatar-uploader-icon2"></i>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb，尺寸 240x170
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="收集用户信息">
        <el-radio-group v-model="info.info_field_status">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="info.info_field_status==1">
        <el-checkbox-group v-model="info.info_field">
          <el-checkbox label="contact_name" disabled>学生姓名</el-checkbox>
          <el-checkbox label="contact_phone" disabled>手机号码</el-checkbox>
          <el-checkbox label="address">收货地址</el-checkbox>
          <el-checkbox label="wechat_id">微信号</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="状态">
        <el-radio-group v-model="info.status">
          <el-radio :label="1">发布</el-radio>
          <el-radio :label="0">下架</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item>
        <el-button
            size="small"
            type="primary"
            @click="createUpdate()"
            :loading="updateLoading"
        >确 定
        </el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import tinymce from "@/components/tinymce.vue";

import {
  imageUploadOSSRequest,
  beforeImageUpload,
  uploadOSSRequest,
  getAliyunOssToken,
  getTeacherList
} from "@/api/common";

import {consultDataSave, consultInfo} from "@/api/consult";

export default {
  data: function () {
    return {
      isshow: false,
      ossAction: "",
      ossData: {},
      loading: false,
      aliyunOssToken: "",
      updateLoading: false,
      categoryList: [],
      teacherList: [],
      editor: null,
      info: {
        id: 0,
        title: "",
        detail: "",
        img_url: "",
        status: 0,
        price: 0,
        ios_price: 0,
        discount_price: 0,
        ios_discount_price: 0,
        wechat_img: "",
        is_discount: 0,
        info_field_status: 0,
        info_field: ["contact_name", "contact_phone"]
      },
    };
  },
  components: {
    tinymce,
  },
  created: function () {
    getTeacherList().then((response) => {
      this.teacherList = response.data;
    });
    this.info.id = this.$route.query.id;
    if (this.info.id > 0) {
      this.getInfo();
    }
  },
  mounted() {
  },
  methods: {
    beforeImageUpload(file) {
      beforeImageUpload(file);
    },
    imageUploadOSSRequest3(file) {
      getAliyunOssToken({dir: ""}).then((res) => {
        imageUploadOSSRequest(file.file, res.data, 500).then((fileUrl) => {
          this.info.wechat_img = fileUrl;
        });
      });
    },
    uploadOSSRequest(file) {
      getAliyunOssToken({dir: ""}).then((res) => {
        uploadOSSRequest(file.file, res.data).then((fileUrl) => {
          this.info.img_url = fileUrl;
        });
      });
    },

    getInfo() {
      this.loading = true;
      consultInfo({
        id: this.info.id,
      }).then((response) => {
        this.info = response.data;
        console.log(response.data);
        this.loading = false;
      });
    },
    createUpdate() {
      this.updateLoading = true;
      consultDataSave(this.info)
          .then((response) => {
            this.updateLoading = false;
            if (response.code == 1) {
              this.$message.success(response.message);
              this.$router.push({
                path: "/consult/list",
              });
            }
          })
          .catch((err) => {
            this.updateLoading = false;
          });
    },

    ref() {
      window.history.go(-1);
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.hides {
  background: #fff;
  width: 100px;
  height: 100px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
}

.avatar-uploader-icon2 {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar2 {
  width: 100px;
  height: 100px;
  display: block;
}
</style>